import { Button, Grid } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Stack from '@mui/material/Stack';
import axios from "axios";
import MaterialTable, { Localization } from 'material-table';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import 'whatwg-fetch';
import { API_URL, LICENSE } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

const theme = createTheme({
  /*
  palette: {
    secondary: {
      main: "rgba(33, 150, 243, 1) !important",
    },
  },
  */
  overrides: {
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.25) !important"
        }
      }
    }
  }
});

const localizationJapanese: Localization = {
  error: "エラー",
  body: {
    emptyDataSourceMessage: "表示するレコードがありません。",
    filterRow: {
      filterTooltip: "フィルター",
    },
  },
  header: {
    actions: "アクション",
  },
  grouping: {
    groupedBy: "グループ化:",
    placeholder: "ヘッダーをドラッグ ...",
  },
  pagination: {
    firstTooltip: "最初のページ",
    firstAriaLabel: "最初のページ",
    previousTooltip: "前のページ",
    previousAriaLabel: "前のページ",
    nextTooltip: "次のページ",
    nextAriaLabel: "次のページ",
    labelDisplayedRows: "{from}-{to} 全{count}件",
    labelRowsPerPage: "ページあたりの行数:",
    lastTooltip: "最後のページ",
    lastAriaLabel: "最後のページ",
    labelRowsSelect: "件",
  },
  toolbar: {
    nRowsSelected: "{0} 行選択",
  },
};




// 画面表示用
const CorporateList: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()
  const history = useHistory();
  const [posts, setPosts] = useState<any[]>([])
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  useEffect(() => {
    openLoading()
    axios.post(API_URL.COMPANY_LIST,
      {
        "company_id": jsonlist.user.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        // console.log('data:',res.data.data)
        const persons = res.data.data;
        setPosts(persons)

      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);




  // 適切な形式で容量を表示
  const capacity = ({ val }: { val: string }) => {
    const size = Number(val)
    const kb = 1024
    const mb = 1024000
    const gb = 1024000000
    const tb = 1024000000000
    let target = 1
    let unit = 'byte'

    if (size >= tb) {
      target = tb
      unit = 'TB'
    } else if (size >= gb) {
      target = gb
      unit = 'GB'
    } else if (size >= mb) {
      target = mb
      unit = 'MB'
    } else if (size >= kb) {
      target = kb
      unit = 'KB'
    }

    return Math.floor(size / target) + ' ' + unit
  }


  /*配列データ*/
  const rows: any = [];
  posts.map((item) => (
    rows.push({ company_name: item.company_name, company_id: item.company_id, contract_type: LICENSE[item.contract_type], from_date: item.from_date + '〜' + item.to_date, total_user_count: item.total_user_count, total_capacity: capacity({ val: item.total_capacity }), remarks: item.remarks })
  ))

  /*詳細画面へ*/

  const Linkto = (e: any) => {
    history.push({
      pathname: "/CorporateDetail", state:
      {
        company_id: e.company_id,
      }
    });

  }
  /*詳細画面へ*/

  return (

    <GenericTemplate title="契約企業一覧">

      <Grid container spacing={3}>
        <Grid item sm={12} xs={12}>
          <Button
            className="btnlink"
            color="primary"
            variant="contained"
            size="large"
            component={Link}
            to="/CorporateCreate"
          >
            ＋ 契約企業の新規作成
          </Button>
        </Grid>
      </Grid>
      <Stack spacing={3} margin={1}></Stack>

      <ThemeProvider theme={theme}>
        <MaterialTable
          options={{
            search: true,
            draggable: true,
            filtering: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: '#ececec',
              color: '#000',
              textAlign: "left",
              fontWeight: "600",
            },
          }}
          columns={[

            {
              title: '企業名',
              field: 'company_name',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '企業ID',
              field: 'company_id',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '契約形態',
              field: 'contract_type',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '契約期間',
              field: 'from_date',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '最大ユーザー数',
              field: 'total_user_count',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '最大容量',
              field: 'total_capacity',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '備考',
              field: 'remarks',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
          ]}
          data={rows}
          title="工事一覧"
          onRowClick={(event, rowData,) => Linkto(rowData)}
          localization={localizationJapanese}
        />
      </ThemeProvider>


    </GenericTemplate>
  );
};

export default CorporateList;